/* __next_internal_client_entry_do_not_use__ getSettingValueAndAssign,getSettingValueWithoutAssignment,assignSetting auto */ import { getSettingsValues } from "@faire/retailer-visitor-shared/serialized-data/getSettingsValues";
import { getSettingFactory } from "@faire/web--source/common/SerializedSetting";
/**
 * Functions that provides synchronous access to settings that are serialized to the page, while handling frontend
 * overrides and default values if the setting is missing.
 *
 * RSC: these functions only work in client components. Consider migrating uses to client
 * components (which can be server rendered!) or using fetchServerSideSetting
 */ var _getSettingFactory = getSettingFactory(function() {
    return getSettingsValues();
}), getSettingValueAndAssign = _getSettingFactory.getSettingValueAndAssign, getSettingValueWithoutAssignment = _getSettingFactory.getSettingValueWithoutAssignment, assignSetting = _getSettingFactory.assignSetting;
export { /**
 * @deprecated Use useSetting and useAssignSetting instead.
 */ getSettingValueAndAssign, /**
 * @deprecated Use useSetting instead.
 */ getSettingValueWithoutAssignment, /**
 * @deprecated Use useAssignSetting instead.
 */ assignSetting };
